<style lang='less' scoped>
@import '../base.less';
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>


            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.articleTypeId' :placeholder="$t('类型Id') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('用户名') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.title' :placeholder="$t('标题') "></Input>
            </FormItem>

            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->

    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary'  @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label="类型ID">
          <Input :disabled="windowAddItem.id>0" clearable v-model='windowAddItem.articleTypeId' :placeholder="$t('请输入类型ID')"></Input>
        </FormItem>
        <FormItem label="文章ID">
          <Input :disabled="windowAddItem.id>0" clearable v-model='windowAddItem.articleId' :placeholder="$t('请输入文章ID')"></Input>
        </FormItem>
        <FormItem label='用户名' >
          <Input clearable v-model='windowAddItem.username' :placeholder="$t('用户名')"></Input>
        </FormItem>
        <FormItem label='阅读数'>
          <Input clearable v-model='windowAddItem.clickCount' :placeholder="$t('阅读数')"></Input>
        </FormItem>
        <FormItem label='粉丝数'>
          <Input clearable v-model='windowAddItem.fansCount' :placeholder="$t('粉丝数')"></Input>
        </FormItem>
        <FormItem label='点赞数' >
          <Input clearable v-model='windowAddItem.userThumbUpCount' :placeholder="$t('点赞数')"></Input>
        </FormItem>
        <FormItem label='创建时间' >
          <Input clearable v-model='windowAddItem.createTime' :placeholder="$t('创建时间')"></Input>
        </FormItem>
        <FormItem label='资料内容' >
            <Button type="text" @click="isHtml=!isHtml" class="margin-left-10">{{
                $t('编辑源码')
              }}
            </Button>

            <div v-if="isHtml==false" style="border: 1px solid #ccc;">
              <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
              />
              <Editor
                style="height: 200px; overflow-y: hidden;"
                v-model="windowAddItem.description"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onCreated="onCreated"
              />
            </div>
            <textarea v-if="isHtml==true" v-model="windowAddItem.description" name="ckeditor" rows="10"
                      cols="80"></textarea>
            <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
          </FormItem>

      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import {
  baseUrl
} from '@/libs/api.request'
import {
  getToken
} from '@/libs/util'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
export default {
  name: 'interface_list',
  components: {Editor, Toolbar},
  data() {
    return {
      editor: null,
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default', // or 'simple',
      uploadUrlCk: baseUrl + 'Index/uploadCk',
      uploadUrl: baseUrl + 'Index/upload',
      uploadHeader: {
        'Authorization': "bearer " + getToken()
      },
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [ {
        title: this.$t('用户名'),
        key: 'username',
        minWidth: 50,
        align: 'center'
      },{
        title: this.$t('标题'),
        key: 'title',
        minWidth: 50,
        align: 'center'
      },{
        title: this.$t('类型ID'),
        key: 'articleTypeId',
        minWidth: 50,
        align: 'center'
      },{
        title: this.$t('点赞数'),
        key: 'userThumbUpCount',
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('粉丝数'),
        key: 'fansCount',
        minWidth: 50,
        align: 'center'
      },{
        title: this.$t('阅读数'),
        key: 'clickCount',
        minWidth: 50,
        align: 'center'
      },{
        title: this.$t('创建时间'),
        key: 'createTime',
        minWidth: 50,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem.id=params.row.id;
                vm.windowAddItem.username=params.row.username;
                vm.windowAddItem.clickCount=params.row.clickCount;
                vm.windowAddItem.fansCount=params.row.fansCount;
                vm.windowAddItem.userThumbUpCount=params.row.userThumbUpCount;
                vm.windowAddItem.createTime=params.row.createTime;
                vm.windowAddItem.articleId=params.row.articleId;
                vm.windowAddItem.articleTypeId=params.row.articleTypeId;
                vm.windowAddItem.description=params.row.description;
                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要采集内容?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('tuku/ZiliaoData', {op: 'caiji', id: params.row.id}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList();
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('采集'))
          ])])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      isHtml:false,
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddItemTemp: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created() {
    let vm = this
    customPost('tuku/Pinglun', {op: 'getLotteryTypes'}).then(response => {
      vm.lotteryParams = response.data.data;
      vm.getList();
    })
  },
  mounted() {

  },
  methods: {
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page= vm.tableShow.currentPage
      vm.searchConf.size= vm.tableShow.pageSize
      customPost('tuku/ZiliaoData', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    preAdd() {
      let vm = this
      vm.windowAddItem.id=0;
      vm.windowAddItem.username="";
      vm.windowAddItem.clickCount="0";
      vm.windowAddItem.fansCount="0";
      vm.windowAddItem.userThumbUpCount="0";
      vm.windowAddItem.createTime="";
      vm.windowAddItem.articleId="";
      vm.windowAddItem.articleTypeId="";
      vm.windowAddItem.description="";
      vm.windowAdd.show = true
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
        this.$refs['windowAddForm'].resetFields()
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          Object.assign(vm.windowAddItemTemp, vm.windowAddItem) //浅复制数据params.row 给 vm.windowAddItemTemp
          vm.windowAddItemTemp.op='save';
          customPost('tuku/ZiliaoData',vm.windowAddItemTemp).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
